import React, { useEffect, useState } from 'react';
import { callApiWithAuthorization } from '../../../../API/CallApi';
import SolutionCards from '../SolutionCards';
import SolutionDetail from '../SolutionDetail';
import { useMsal } from '@azure/msal-react';

function RecommendedLibraryProjects({ tags, importApp, onProjectsLoaded, user }) {

    const [loading, setLoading] = useState(true);
    const [projects, setProjects] = useState([]);
    const [selectedSolution, setSelectedSolution] = useState(null);
    const [importingSchema, setImportingSchema] = useState(false);
    
    async function getProjects() {
        const tagString = tags.join(',').toLowerCase();
        const request = await callApiWithAuthorization("/api/v0/library/project?tags="+tagString);
        const projects = await request.json();
        projects.forEach(project => {
            if (project.tags)
                project.tags = project.tags.split(',')
        });
        setProjects(projects);
        setLoading(false);
        if (onProjectsLoaded && typeof onProjectsLoaded === "function") {
            onProjectsLoaded(projects);
        }
    }

    async function handleImport(solution) {
        try {
            setImportingSchema(true);
            await importApp(solution);
        } catch (e) {
            console.error(e);
        } finally {
            setImportingSchema(false);
        }
    }

    useEffect(() => {
        getProjects();
    }, [])

    if (loading) {
        return (
            <div>
                Loading...
            </div>
        )
    }

    if (importingSchema) {
        return (
            <div className='h-100 w-100 d-flex justify-content-center'>
                <img
                    alt="Loader"
                    height={"100%"}
                    src={`${process.env.REACT_APP_DATALAKESTORAGE_URL}/${process.env.REACT_APP_DATALAKESTORAGE_RESOURCES}/images/loaders/library.gif`} />
            </div>
        )
    }

    if (selectedSolution) {
        return (
            <SolutionDetail
                onBack={() => setSelectedSolution(null)}
                UseSolutionTemplate={handleImport}
                solution={selectedSolution} />
        )
    }

    return (
        <div className="container-fluid">
            <div className="row">
                <div className='col-12'>
                    We have some library projects with the same tags.
                </div>
            </div>
            <div className='row'>
                    {
                        projects.map(project => (
                            <div className="col-4 my-2" key={project.id}>
                                <SolutionCards
                                    user={user}
                                    solution={project}
                                    UseSolutionTemplate={handleImport}
                                    selectSolutions={(solution) => setSelectedSolution(solution)} />
                            </div>
                        ))
                    }
            </div>
        </div>
    )
}

RecommendedLibraryProjects.defaultProps = {
    tags: []
}

export default RecommendedLibraryProjects;